import { forwardRef } from 'react';
import { Strong as RadixStrong } from '@radix-ui/themes';
import type { RadixStrongProps } from '@/types/radix-ui';

/**
 * Strong component - wrapper around Radix UI Strong
 * Provides semantic strong emphasis for text
 */
export type StrongProps = RadixStrongProps;

const Strong = forwardRef<HTMLElement, StrongProps>((props, ref) => {
  return <RadixStrong ref={ref} {...props} />;
});

Strong.displayName = 'Strong';

export { Strong };
